import styled from 'styled-components';

export const SearchFieldContainer = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  background: #f2f2f2;
  align-items: center;
  padding: 0 1%;
  margin-right: 10px;
  // transparent border preoccupies space for "focused" border, and prevents jumpy behavior
  border: 1px solid transparent;

  border-radius: ${({ theme }) => theme.borderRadius};
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 70%;
  }
  &:focus-within {
    outline: none !important;
    border: 1px solid #219ad6;
  }
`;

export const SearchInput = styled.input`
  //border: 1px solid red;
  width: 80%;
  background: #f2f2f2;
  outline: none;
  border: 0;
  font-size: 1.2rem;
  &::placeholder {
    font-size: 1rem;
  }
`;

export const SuggestionList = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: calc(100% + 7px);
  left: 0;
  width: 100%;

  background: white;
  border-radius: ${({ theme }) => theme.borderRadius};
  //box-shadow: rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);

  //transform: scaleY(0);
  transform: scaleY(1);
  transform-origin: top;
  transition: transform 0.26s ease;
`;

export const SuggestionListItem = styled.div`
  padding: 15px 10px;
  font-size: 0.9rem;
  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }
`;

export const ItemSKU = styled.div`
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 3px;
`;

export const ItemName = styled.div``;

export const Label = styled.label`
  font-size: 1.2rem;
  padding: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
`;
